export enum Path {
  MOVIE_DETAIL = 'app/movie-detail',
  WEB_SERIES = 'app/web-series',
  FILM_PATH = '/viewer/film',
  WEB_SERIES_PATH = '/viewer/web-series',
  ABC_LOGO = '/assets/images/abc-logo.svg',
}

export enum PageType {
  MOVIE_DETAIL = 'movie-detail',
  WEB_SERIES = 'web-series',
}

export enum MediaType {
  MOVIE = 'movie',
  WEB_SERIES = 'web-series',
}
